import script from "./SelectAreaList.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectAreaList.vue?vue&type=script&lang=ts&setup=true"

import "./SelectAreaList.vue?vue&type=style&index=0&id=4f4052ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f4052ae"]])

export default __exports__